module.exports = "<article class=cities> <div class=\"background background--overview background--cities\"> <h1 class=\"overview__title overview__title--cities\">city guides</h1> <section class=\"explore explore--overview\"> <ul class=\"explore__list js-cities-scroll-action\"> {{#each cities}} <li class=explore__thumb> <a class=\"explore__link js-link-internal\" href={{this.url}}> <h2 class=explore__name>{{this.name}}</h2> <div class=explore__media style=background-image:url({{this.img}})></div> </a> </li> {{/each}} </ul> </section> </div> </article> ";


//////////////////
// WEBPACK FOOTER
// ./templates/cities.html
// module id = 57
// module chunks = 0